module.exports = __webpack_public_path__ + "img/921_part1_cover.edf73a82.jpg";